//@flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import getter from 'dibs-object-getter';
import { firmStatuses } from '../constants';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { Button } from 'dibs-elements/exports/Button';

import styles from './LoyaltyModulesWrapper.scss';

import PanelText from '../shared/PanelText';

import type { InviteColleagues_tradeFirm as tradeFirmType } from './__generated__/InviteColleagues_tradeFirm.graphql';

type InviteColleaguesProps = {
    tradeFirm: tradeFirmType,
};

const InviteColleagues = (props: InviteColleaguesProps) => {
    const firmStatus = getter(props)
        .at('tradeFirm')
        .value('firmStatus');

    if (firmStatus !== firmStatuses.ACTIVE) {
        return null;
    }

    return (
        <div data-tn="invite-colleagues-header">
            <BarHeader
                dataTn="invite-colleagues-header"
                size="xLarge"
                title={
                    <FormattedMessage
                        id="rewards.RewardsWrapper.inviteColleaguesHeader"
                        defaultMessage="Invite Colleagues"
                    />
                }
            />
            <div className={styles.splitInfoPanel}>
                <div className={styles.referralImage} />
                <div className={styles.splitInfoPanelDescription}>
                    <PanelText
                        headerCopy={
                            <FormattedMessage
                                id="rewards.RewardsWrapper.earnRewardsHeader"
                                defaultMessage="Earn Rewards Faster"
                            />
                        }
                        exposition={
                            <FormattedMessage
                                id="rewards.RewardsWrapper.earnRewardsExplanation"
                                defaultMessage="Invite your colleagues to enroll in Trade Rewards and their purchases will also count toward your firm’s collective rewards."
                            />
                        }
                    >
                        <Button
                            className={styles.inviteCta}
                            type="primary"
                            size="medium"
                            href="/trade/referral/"
                            dataTn="trade-referal-invite-colleagues-cta"
                        >
                            <FormattedMessage
                                id="rewards.RewardsWrapper.earnRewardsCta"
                                defaultMessage="Invite Colleagues"
                            />
                        </Button>
                    </PanelText>
                </div>
            </div>
        </div>
    );
};

export { InviteColleagues };

export default createFragmentContainer(
    InviteColleagues,
    graphql`
        fragment InviteColleagues_tradeFirm on TradeFirmType {
            firmStatus
        }
    `
);
